<template>
    <div>
        <CustomTable
            :items.sync="tables.fixedFields.items"
            :fields="traslateLabels(tables.fixedFields.fields)"
            :resizable="resizable"
            v-bind="tables.fixedFields"
        >
            <template v-slot:[nameKey]="{ index }">
                <CInput
                    :value.sync="tables.fixedFields.items[index][nameKey]"
                    :placeholder="$t('Enter the ' + nameLabel)"
                    :invalidFeedback="$t(nameLabel + ' is required')"
                    class="mb-0"
                    size="sm"
                />
            </template>
            <template v-slot:[valueKey]="{ index }">
                <CInput
                    :value.sync="tables.fixedFields.items[index][valueKey]"
                    :placeholder="$t('Enter the ' + valueLabel)"
                    :invalidFeedback="$t(valueLabel + ' is required')"
                    class="mb-0"
                    size="sm"
                />
            </template>
            <template #options="{ index }">
                <div class="table-options">
                    <CButton
                        color="danger"
                        variant="outline"
                        square
                        size="sm"
                        @click="deleteItemToTable('fixedFields', index)"
                    >
                        <CIcon
                            class="icon"
                            :content="$options.icons.cilTrash"
                        />
                    </CButton>
                </div>
            </template>
            <template #no-items-view>
                <div class="block-no-items section">
                    <h2 class="section__title text-no-items">
                        {{ $t("add_fixed_field") }}
                    </h2>
                    <ButtonAdd
                        @click="addItemToTable('fixedFields')"
                        v-if="tables.fixedFields.items.length == 0"
                    />
                </div>
            </template>
            <template #under-table>
                <ButtonAdd
                    @click="addItemToTable('fixedFields')"
                    v-if="tables.fixedFields.items.length > 0"
                />
            </template>
        </CustomTable>
    </div>
</template>

<script>
/**Components */
import ButtonAdd from "~/components/ButtonAdd.vue";
import ButtonTrash from "~/components/ButtonTrash.vue";
import CustomTable from "~/components/CustomTable";
/** Mixins */
import tableMixin from "~/mixins/table.js";
import traslateMixin from "~/mixins/traslate.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import FilterTypeOptions from "~/pages/app/config/options/filter_type";


const defaultFieldNameKey = "name";
const defaultFieldNameLabel = "name";
const defaultFieldValueKey = "value";
const defaultFieldValueLabel = "value";

export default {
    name: "TableFixedFields",
    mixins: [traslateMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    options: {
        FilterTypeOptions,
    },
    components: {
        CustomTable,
        ButtonAdd,
        ButtonTrash
    },
    data() {
        return {
            tables: {
                fixedFields: {
                    items: [],
                    fields: [
                        {
                            key: defaultFieldNameKey,
                            label: defaultFieldNameLabel,
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                            _type: "String",
                        },
                        {
                            key: defaultFieldValueKey,
                            label: defaultFieldValueLabel,
                            sorter: false,
                            filter: false,
                            _style: "width:30%",
                            _type: "String",
                        },
                        {
                            key: "options",
                            label: "options",
                            sorter: false,
                            filter: false,
                            _style: "width:10%",
                            _type: "Boolean",
                        },
                    ],
                    loading: false,
                },
            },
            modals: {},
            modelFields: [],
        };
    },
    props: {
        nameKey: {
            default: "name",
        },

        nameLabel: {
            default: "name",
        },

        valueKey: {
            default: "value",
        },

        valueLabel: {
            default: "value",
        },

        resizable:{
            default: false,
        },

        value: {
            default: () => {
                return [];
            },
            type: Array | Object,
        },
    },
    watch: {
        "tables.fixedFields.items": {
            handler(newValue) {
                this.$emit("update:value", newValue);
                this.$emit("change", newValue);
            },
            deep: true,
        },
        value(newValue) {
            if (Array.isArray(newValue)) {
                this.tables.fixedFields.items = newValue;
            }
        },
    },
    methods: {},
    mounted() {
        if (Array.isArray(this.value)) {
            this.tables.fixedFields.items = this.value;
        }
        if(this.nameKey != defaultFieldNameKey){
            this.tables.fixedFields.fields[0].key = this.nameKey;
        }
        if(this.nameLabel != defaultFieldNameLabel){
            this.tables.fixedFields.fields[0].label = this.nameLabel;
        }
    },
};
</script>

<style>
</style>